import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';
import { GuildMenuItem } from "../../../components/misc/GuildMenuItems"
import { useFetchPlayerGuild } from "../../../utils/hooks/useFetchPlayerGuild"
import { PlayerContext } from '../../../utils/contexts/PlayerContext';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs'
import { Guild } from '../../../utils/types';
import styles from './index.module.scss'
import add from './add.module.scss'
import { Spinner } from '../../../components/misc/Spinner'
import { BiAddToQueue } from "react-icons/bi";

const MenuPage = () => {
  const { guilds, loading } = useFetchPlayerGuild();
  const navigate = useNavigate();
  const { updatePlayerGuild } = useContext(PlayerContext);

  const handleClick = (guild: Guild) => {
    updatePlayerGuild(guild);
    navigate(`/player/panel`);
  };

  const inviteClick = () => {
    navigate(`/invite`);
  }

  if (loading) return <Spinner children={<MoonLoader size={40} color="white" />} />;
  
  return (
    <div>
      <div className="page">
          <div className={styles.container}>
              <head>
                  <title>Menu</title>
                  <meta name="viewport" content="initial-scale=1.0, width=device-width" />
              </head>
              <div className={styles.header}>
                <h1 className={styles.title}>Please Select a Player Room [BETA]</h1>
                <div onClick={() => navigate('/menu')}>
                  <BsFillArrowLeftCircleFill size={35} color="#ffffff"/>
                </div>
              </div>
              {guilds && guilds.map((guild) => (
                  <div key={guild.id} onClick={() => handleClick(guild)}>
                    <GuildMenuItem guild={guild}/>
                  </div>
              ))}
          <div onClick={() => inviteClick()}>
            <div className={add.container}>
                <BiAddToQueue size={55} color="#ffffff"/>
                <div className={add.line}/>
                <p className={add.text}>{"Invite your bot to new guild!"}</p>
            </div>
          </div>
          </div>
      </div>
    </div>
  )
  
}

export default MenuPage